import { render, staticRenderFns } from "./CollectionSkuNoExchange.vue?vue&type=template&id=48538ac1&scoped=true"
import script from "./CollectionSkuNoExchange.vue?vue&type=script&lang=js"
export * from "./CollectionSkuNoExchange.vue?vue&type=script&lang=js"
import style0 from "./CollectionSkuNoExchange.vue?vue&type=style&index=0&id=48538ac1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48538ac1",
  null
  
)

export default component.exports